import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    makeStyles
} from '@material-ui/core'
import { BackdropProgress } from '@zmvp/material-ui'
import React from 'react'

import { CustomDialogTitle } from 'components'

const useStyles = makeStyles(theme => ({
    contentContainer: {
        outline: 'none',
        width: 600,
        [theme.breakpoints.down('xs')]: {
            width: 350
        },
        [theme.breakpoints.down(500)]: {
            width: 300
        }
    },
    errorText: {
        textAlign: 'end',
        padding: 8
    }
}))

export default React.forwardRef(function FormDialog(
    { children, title, actions, isLoading, onClose, hasStatusError, ...props },
    ref
) {
    const [isOpen, setIsOpen] = React.useState(false)
    const textRef = React.useRef()

    ref.current = {
        open: () => setIsOpen(true),
        close: () => setIsOpen(false),
        toggle: state => setIsOpen(state)
    }

    React.useEffect(() => {
        if (isOpen) {
            if (textRef.current) {
                textRef.current.focus()
            }
        }
    }, [isOpen])

    const classes = useStyles()

    if (isLoading) {
        return <BackdropProgress />
    }

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            scroll="paper"
            maxWidth="lg"
            {...props}
        >
            <form noValidate>
                <DialogTitle disableTypography>
                    <CustomDialogTitle title={title} onClose={onClose} />
                </DialogTitle>
                <DialogContent>
                    <div
                        ref={textRef}
                        tabIndex={-1}
                        className={classes.contentContainer}
                    >
                        {children}
                    </div>
                </DialogContent>
                <DialogActions>{actions}</DialogActions>
            </form>
            {hasStatusError?.error && (
                <Typography
                    variant="caption"
                    color="error"
                    className={classes.errorText}
                >
                    {hasStatusError.message}
                </Typography>
            )}
        </Dialog>
    )
})
